<template>
  <form class="col-12 b-form b-dialog__form">
    <div class="row mt-5 b-form__row_type_flex-end">
      <div class="col-12">
        <label>{{$t('CONTENT.indexation.indexation_kind_name')}}:</label>
        <input type="text" class="b-input" v-model="indexationKind">
      </div>
    </div>
    <div class="row mt-5 b-form__row_type_flex-end">
      <div class="col-12">
        <label>
          {{$t('CONTENT.indexation.indexation_type_name')}}:
        </label>
        <cool-select :list="allIndexationKinds"
                     option-value="typeNumber"
                     option-text="typeName"
                     v-model="form.typeNumber"
                     :isDisabled="isDisabledField"
                     :placeholder="$t('CONTENT.choose')"
                     @change="selectIndexationType($event)"></cool-select>
      </div>
    </div>
    <div class="row mt-5">
      <div class="col-6 offset-6">
        <div
          class="b-form__container b-form__container_type_flex b-form__container_type_flex_end"
        >
          <button
            data-cy="save-create-asset"
            class="b-btn b-btn_type_primary"
            type="button"
            @click="save"
            :disabled="isDisabledSaveBtn"
          >{{$t('CONTENT.save')}}
          </button>
          <button
            data-cy="cancel-create-asset"
            type="text"
            class="b-btn b-btn_type_empty m-2"
            @click.prevent="cancel"
          >{{$t('CONTENT.cancel')}}
          </button>
        </div>
      </div>
    </div>
  </form>
</template>

<script>
	import Indexation from "../../models/Indexation";

  export default {
    props: {
      currentIndexation: {
        type: Object | null,
        required: true,
      },
      allIndexationKinds: {
        type: Array,
      }
    },
    data(){
      return {
        form: {},
      }
    },
    created() {
      if (this.currentIndexation) {
        this.form = _.clone(this.currentIndexation);
      } else {
        this.form = Indexation.createNew();
      }
    },
    computed: {
      isDisabledField() {
        if (this.form.id !== null) {
          return true;
        }
      },
      isDisabledSaveBtn() {
        if (this.form === null ||
          this.form.name === null ||
          this.form.name === '' ||
          this.form.typeNumber === null) {
          return true;
        }
      },
      indexationKind: {
       get() {
         return this.form.name;
        },
        set(newVal) {
          this.form.name = newVal;
        }
      },
    },
    methods: {
      selectIndexationType(value) {
        this.form.typeNumber = +value;
      },
      save(event) {
        event.preventDefault();
        this.$emit('save', this.form);
      },
      cancel() {
        this.form = {};
        this.$emit('cancel');
      }
    }
  }
</script>
